import { Box, Center, Icon, Img, ScaleFade, SimpleGrid, Spinner } from '@chakra-ui/react'
import React, { Fragment } from 'react'
import { BsDashCircleFill } from 'react-icons/bs';
import { DataContext } from '../../../state/DataContext/DataContext';
import LoadingWrapper from '../LoadingWrapper/LoadingWrapper';
import Loader from '../Loader/Loader';
import DocumentViewer from '../DocumentViewer/DocumentViewer';
import { ImageViewer } from '../ImageViewer/ImageViewer';
import { FileDeleterWrapper } from '../FileDeleteWrapper/FileDeleteWrapper';

export default function FileListViewer(props) {

    // FileListViewer
    // ImageViewer
    // DocumentViewer
    // FileDeleter ==> wraps document and images with a negative button 

    React.useEffect(() => {
        console.log(props.fileArray)
    }, [props.fileArray])

    const [loading, setLoading] = React.useState(true)
    const fileNamesToBeDeleted = [] as any;

    function removeItem(index) {
        if (index > -1) {
            var fileArrayClone = [...props.fileArray]
            fileNamesToBeDeleted.push(fileArrayClone[index])
            fileArrayClone.splice(index, 1);

            props.setFileArray(fileArrayClone);
            props.setFilesToBeDeleted(fileNamesToBeDeleted)
        }
    }

    return (
        <Fragment key={props.uniqueKey}>
            {props.fileArray?.length !== 0 &&
                <SimpleGrid columns={props.isLive ? 1 : 2} spacing={4}>

                    {props.fileArray?.map((file, index) => {
                        return <Box key={`${file.name}-${index}`} >
                            <FileDeleterWrapper index={index} removeItem={removeItem}>

                                {file.type === "image/jpeg" ?
                                    <ImageViewer
                                        setLoading={setLoading}
                                        file={file}
                                        loading={loading} />
                                    : <DocumentViewer
                                        file={file}
                                        loading={loading} />
                                }
                            </FileDeleterWrapper>

                        </Box>
                    })}
                </SimpleGrid>
            }
        </Fragment>
    )
}
